import { render, staticRenderFns } from "./AkitoPage.vue?vue&type=template&id=40fbdf4e"
import script from "./AkitoPage.vue?vue&type=script&lang=js"
export * from "./AkitoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports